module.exports = __webpack_public_path__ + "static/media/list.6bf3a509.svg";